import { compose } from 'recompose';

import PostShow from './PostShow';

const enhance = compose();

export default enhance(PostShow);
